<template>
  <area-container>
    <area-nav :links="links"></area-nav>
    <area-content>
      <router-view></router-view>
    </area-content>
  </area-container>
</template>

<script>
export default {
  name: "DeliveryLayout",
  data() {
    return {
      links: [
        {
          route: "delivery.Delivery",
          name: this.$tk("DeliveryLayout.Delivery")
        },
        {
          route: "delivery.External",
          name: this.$tk("DeliveryLayout.ExternalLocations")
        }
      ]
    }
  }
}
</script>
